// Module
var code = "<div class=\"basket-shipping-message__content\"> <span class=\"basket-shipping-message__label\">[[YourOrderQualifiesFor]]</span> <span class=\"basket-shipping-message__text\">{{message}}</span> </div>";
// Exports
module.exports = code;